import { Button } from "./Button";
import { cx } from "./cx";

export interface PaginationProps {
  page: number; // 1-based
  pageCount: number;
  total?: number;
  onPageChange: (page: number) => void;
  className?: string;
}

/**
 * Pagination — 1-based, keyboard-operable (buttons), RTL-safe (logical chevrons via labels).
 * Disables the edges; announces the position for AT.
 */
export function Pagination({ page, pageCount, total, onPageChange, className }: PaginationProps) {
  const safeCount = Math.max(1, pageCount);
  const atStart = page <= 1;
  const atEnd = page >= safeCount;
  return (
    <nav className={cx("nv-pagination", className)} aria-label="Pagination">
      <span className="nv-pagination__info">
        Page <strong>{page}</strong> / {safeCount}
        {total !== undefined ? ` · ${total} éléments` : ""}
      </span>
      <Button
        variant="secondary"
        size="sm"
        disabled={atStart}
        onClick={() => onPageChange(page - 1)}
        aria-label="Page précédente"
      >
        ‹ Préc.
      </Button>
      <Button
        variant="secondary"
        size="sm"
        disabled={atEnd}
        onClick={() => onPageChange(page + 1)}
        aria-label="Page suivante"
      >
        Suiv. ›
      </Button>
    </nav>
  );
}
